import type { ReactNode } from 'react';
import styled from 'styled-components';

import { SecondaryPageBackground } from '@sorare/core/src/atoms/ui/SecondaryPageBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import type { Color } from '@sorare/core/src/style/types';

const Root = styled(Bezel)`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: var(--triple-unit) var(--double-unit);
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(
    180deg,
    transparent 0%,
    rgba(var(--c-rgb-black), 0.85) 100%
  );
`;

type Props = {
  color: Color;
  children: ReactNode;
};

export const FeaturedMissionCard = ({ color, children }: Props) => {
  return (
    <Root borderColor={color}>
      <SecondaryPageBackground
        overlayStartColor={`color-mix(in srgb, ${color} 50%, transparent)`}
        overlayMidColor="var(--c-black)"
        overlayEndColor="var(--c-black)"
        contained
      />
      <Overlay />
      {children}
    </Root>
  );
};
